import { ApplyStatusType, PER_PAGE_TYPES, SaleStatusType } from "enums";
import { ApplyItemSearchOptions, CategoryModel } from "models";
import React from "react";
import ExhibitSearchItemCategoryInputs from "./ExhibitSearchItemCategoryInputs";

type PROPS = {
  category: React.MutableRefObject<CategoryModel[]>;
  options: ApplyItemSearchOptions;
  onSearch: (options: ApplyItemSearchOptions) => void;
};

/** 出品一覧の検索条件 */
const ExhibitSearchOptionsArea: React.FC<PROPS> = (props) => {
  const category = props.category;
  const options = props.options;

  // 販売ステータス
  const [saleStatus, setSaleStatus] = React.useState(-1);
  // 申請ステータス
  const [applyStatus, setApplyStatus] = React.useState(-1);
  // キーワード
  const [keyword, setKeyword] = React.useState("");

  // 商品カテゴリのコンポーネントを再描画するためのキー
  const [reRenderKey, setReRenderKey] = React.useState(0);

  React.useEffect(() => {
    console.log("aaa");
    if (props.options.sale_status !== undefined) {
      setSaleStatus(props.options.sale_status);
    } else {
      setSaleStatus(-1);
    }
    if (props.options.apply_status !== undefined) {
      setApplyStatus(props.options.apply_status);
    } else {
      setApplyStatus(-1);
    }
    if (props.options.keyword !== undefined) {
      setKeyword(props.options.keyword);
    } else {
      setKeyword("");
    }
  }, [
    props.options.apply_status,
    props.options.keyword,
    props.options.sale_status,
  ]);

  const onReset = () => {
    // setSaleStatus(-1);
    // setApplyStatus(-1);
    // setKeyword("");
    // delete props.options.sale_status;
    // delete props.options.apply_status;
    // delete props.options.keyword;
    // delete props.options.apply_item_large_category_id;
    // delete props.options.apply_item_medium_category_id;
    // delete props.options.apply_item_small_category_id;

    for (let k in props.options) {
      delete (props.options as any)[k];
    }
    props.options.get_count = PER_PAGE_TYPES.DEFAULT;
    props.onSearch(props.options);
    setReRenderKey(reRenderKey + 1);
  };

  return (
    <div className="m-4 border rounded p-4 flex flex-col gap-2">
      <div className="flex justify-between gap-4">
        <div className="flex items-center gap-4">
          <div>販売ステータス</div>
          <select
            className="w-40"
            value={saleStatus}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              if (isNaN(value) || value < 0) {
                delete options.sale_status;
                setSaleStatus(-1);
              } else {
                options.sale_status = value;
                setSaleStatus(value);
              }
            }}
          >
            <option value={-1}>すべて</option>
            <option value={SaleStatusType._1_HANBAI_CHU}>販売中</option>
            <option value={SaleStatusType._2_TEISHI}>販売停止</option>
            <option value={SaleStatusType._0_MI_TOUROKU}>未登録</option>
          </select>
        </div>
        <div className="flex items-center gap-4">
          <div>承認ステータス</div>
          <select
            className="w-40"
            value={applyStatus}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              if (isNaN(value) || value < 0) {
                delete options.apply_status;
                setApplyStatus(-1);
              } else {
                options.apply_status = value;
                setApplyStatus(value);
              }
            }}
          >
            <option value={-1}>すべて</option>
            <option value={ApplyStatusType._0_WAIT}>承認待ち</option>
            <option value={ApplyStatusType._1_APPROVED}>承認済み</option>
            <option value={ApplyStatusType._2_REPUDIATION}>否認</option>
          </select>
        </div>
      </div>
      <ExhibitSearchItemCategoryInputs
        category={category.current}
        options={options}
        reRenderKey={reRenderKey}
      />
      {/* <div>{JSON.stringify(options)}</div> */}
      <div className="flex justify-between items-center gap-4">
        <div>キーワード</div>
        <div className="flex-1 flex gap-2">
          <input
            className="flex-1"
            value={keyword}
            onChange={(e) => {
              const value = e.target.value;
              if (!value) {
                delete options.keyword;
              } else {
                options.keyword = value;
              }
              setKeyword(value);
            }}
            maxLength={50}
          />
          <button
            className="primary px-4 py-2"
            onClick={() => {
              props.onSearch(options);
            }}
          >
            検索
          </button>
          <div className="mt-2 underline cursor-pointer" onClick={onReset}>
            検索条件を解除
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExhibitSearchOptionsArea;
